import { useContext, useEffect } from 'react';
import { Wrapper, PageWrapper, ContentWrapper } from './styles';
import { ICashlessCardDetails } from '@interfaces/partnership/cashlesscard';
import Header from './header';
import CardDetails from './cardDetails';
import Instruction from './instruction';
import Footer from './footer';

// events
import { SegmentEventNameTypes } from '@utils/segment/constants';
import {
    InternetFnolViewEvents,
    InternetFnolPageTypes,
    InternetFnolPages,
} from '@utils/segment/types';

// context
import { PartnershipContext } from '@components/partnership/context/types';

function cardInstructions({
    name,
    uhid,
    policyNumber,
    relationship,
    policyid,
}: ICashlessCardDetails) {
    const { sendSegmentEventForInternet } = useContext(PartnershipContext);

    useEffect(() => {
        sendSegmentEventForInternet(SegmentEventNameTypes.VIEW, {
            page_type: InternetFnolPageTypes.PDP_HEALTH_CARD,
            page_name: InternetFnolPages.POLICY_DISPLAY_PAGE,
            view_name: InternetFnolViewEvents.VIEW_PDP_HEALTH_CARD,
        });
    }, []);

    return (
        <PageWrapper>
            <ContentWrapper>
                <Header policyid={policyid} />
                <Wrapper>
                    <CardDetails
                        name={name}
                        uhid={uhid}
                        policyNumber={policyNumber}
                        relationship={relationship}
                    />
                    <Instruction />
                </Wrapper>
                <Footer />
            </ContentWrapper>
        </PageWrapper>
    );
}

export default cardInstructions;
